<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="isDisabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите страну" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="op.title | uiLabel" [nzValue]="op.id"></nz-option>
</nz-select>
